import ko from "knockout";
import numeral from "numeral";
import {FilterModel} from "../planning/filter-model";
import {ProfitabilityMetricsDailyModel} from "./profitability-metrics-daily-model";

export class ProfitabilityMetricsSummaryModel {
    filterModel: KnockoutObservable<FilterModel>;
    
    expectedWeeklyRevenue: KnockoutComputed<string>;
    plannedWeeklyRevenue: KnockoutComputed<string>;
    currentWeeklyRevenueText: KnockoutComputed<string>;
    expectedWeeklyLabourProductivity: KnockoutComputed<string>;
    plannedWeeklyLabourProductivity: KnockoutComputed<string>;
    currentWeeklyLabourProductivityText: KnockoutComputed<string>;
    weeklyCostsText: KnockoutComputed<string>;
    plannedWeeklyCosts: KnockoutComputed<string>;
    expectedWeeklyCosts: KnockoutComputed<string>;
    plannedHours: KnockoutComputed<string>;
    expectedHours: KnockoutComputed<string>;
    workedHoursText: KnockoutComputed<string>;
    plannedSalaryCostPercentageNumber: KnockoutObservable<number>;
    expectedSalaryCostPercentageNumber: KnockoutObservable<number>;
    plannedSalaryCostPercentage: KnockoutComputed<string>;
    expectedSalaryCostPercentage: KnockoutComputed<string>;
    currentSalaryCostPercentageText: KnockoutComputed<string>;

    todayIsInDateRangeOrLater: KnockoutObservable<boolean>;
    showAllRevenueData: KnockoutComputed<boolean>;

    dailyMetrics: KnockoutObservableArray<ProfitabilityMetricsDailyModel>;

    constructor(model: any = {}, filterModel: FilterModel) {
        this.filterModel = ko.observable<FilterModel>(filterModel);

        this.expectedWeeklyRevenue = ko.pureComputed(() => numeral(model.expectedWeeklyRevenue).format('$0,0.00'));
        this.plannedWeeklyRevenue = ko.pureComputed(() => numeral(model.plannedWeeklyRevenue).format('$0,0.00'));
        this.currentWeeklyRevenueText = ko.pureComputed(() => `Tot nu toe gerealiseerde omzet: ${numeral(model.currentWeeklyRevenue).format('$0,0.00')}`);

        this.expectedWeeklyLabourProductivity = ko.pureComputed(() => numeral(model.expectedWeeklyLabourProductivity).format('$0,0.00') + ' p/u');
        this.plannedWeeklyLabourProductivity = ko.pureComputed(() => numeral(model.plannedWeeklyLabourProductivity).format('$0,0.00') + ' p/u');
        this.currentWeeklyLabourProductivityText = ko.pureComputed(() => `Tot nu toe gerealiseerde arbeidsproductiviteit: ${numeral(model.currentWeeklyLabourProductivity).format('$0,0.00')} p/u`);

        this.plannedWeeklyCosts = ko.pureComputed(() => numeral(model.plannedWeeklyCosts).format('$0,0.00'));
        this.expectedWeeklyCosts = ko.pureComputed(() => numeral(model.expectedWeeklyCosts).format('$0,0.00'));
        this.weeklyCostsText = ko.pureComputed(() => `Tot nu toe gemaakte loonkosten: ${numeral(model.currentWeeklyCosts).format('$0,0.00')}`);

        this.plannedHours = ko.pureComputed(() => `${model.plannedHours} uur`);
        this.expectedHours = ko.pureComputed(() => `${model.expectedHours} uur`);
        this.workedHoursText = ko.pureComputed(() => `Tot nu toe gewerkte uren: ${model.workedHours} uur`);

        this.plannedSalaryCostPercentageNumber = ko.pureComputed(() => model.plannedSalaryCostPercentage);
        this.expectedSalaryCostPercentageNumber = ko.pureComputed(() => model.expectedSalaryCostPercentage);
        this.plannedSalaryCostPercentage = ko.pureComputed(() => `${numeral(model.plannedSalaryCostPercentage).format('0,0.00')}%`);
        this.expectedSalaryCostPercentage = ko.pureComputed(() => `${numeral(model.expectedSalaryCostPercentage).format('0,0.00')}%`);
        this.currentSalaryCostPercentageText = ko.pureComputed(() => `Tot nu toe gerealiseerd loonkosten percentage: ${numeral(model.currentSalaryCostPercentage).format('0,0.00')}%`);

        this.dailyMetrics = ko.observableArray<ProfitabilityMetricsDailyModel>();
        this.todayIsInDateRangeOrLater = ko.observable(model.todayIsInDateRangeOrLater);

        this.showAllRevenueData = ko.pureComputed(() => this.filterModel().selectedDepartmentId() === undefined);

        if (model.dailyMetrics) {
            const mappedDailyRevenues = model.dailyMetrics.map((dr: any) => new ProfitabilityMetricsDailyModel(dr, this.showAllRevenueData()));
            this.dailyMetrics(mappedDailyRevenues);
        }
    }
}
